// extracted by mini-css-extract-plugin
export default {"emptyMessage":"EmptyMessage_emptyMessage__RHldy"};